(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('lodash/isEqual'), require('axios'), require('lodash/omit'), require('lodash/isEmpty'), require('react'), require('prop-types'), require('lodash/compact'), require('lodash/isObject')) : typeof define === 'function' && define.amd ? define(['lodash/isEqual', 'axios', 'lodash/omit', 'lodash/isEmpty', 'react', 'prop-types', 'lodash/compact', 'lodash/isObject'], factory) : global.LayerManager = factory(global.isEqual, global.axios, global.omit, global.isEmpty, global.React, global.PropTypes, global.compact, global.isObject);
})(this, function (isEqual, axios, omit, isEmpty, react, PropTypes, compact, isObject) {
  'use strict';

  isEqual = isEqual && isEqual.hasOwnProperty('default') ? isEqual['default'] : isEqual;
  var axios__default = 'default' in axios ? axios['default'] : axios;
  omit = omit && omit.hasOwnProperty('default') ? omit['default'] : omit;
  isEmpty = isEmpty && isEmpty.hasOwnProperty('default') ? isEmpty['default'] : isEmpty;
  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
  compact = compact && compact.hasOwnProperty('default') ? compact['default'] : compact;
  isObject = isObject && isObject.hasOwnProperty('default') ? isObject['default'] : isObject;

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  var handleCallback = function handleCallback(resolve, reject, callback, r) {
    try {
      resolve(callback(r));
    } catch (e) {
      reject(e);
    }
  };

  var CancelablePromise = function () {
    createClass(CancelablePromise, null, [{
      key: "all",
      value: function all(iterable) {
        return new CancelablePromise(function (y, n) {
          Promise.all(iterable).then(y, n);
        });
      }
    }, {
      key: "race",
      value: function race(iterable) {
        return new CancelablePromise(function (y, n) {
          Promise.race(iterable).then(y, n);
        });
      }
    }, {
      key: "reject",
      value: function reject(value) {
        return new CancelablePromise(function (y, n) {
          Promise.reject(value).then(y, n);
        });
      }
    }, {
      key: "resolve",
      value: function resolve(value) {
        return new CancelablePromise(function (y, n) {
          Promise.resolve(value).then(y, n);
        });
      }
    }]);

    function CancelablePromise(executor) {
      classCallCheck(this, CancelablePromise);
      this._promise = new Promise(executor);
      this._canceled = false;
    }

    createClass(CancelablePromise, [{
      key: "then",
      value: function then(success, error) {
        var _this = this;

        var p = new CancelablePromise(function (resolve, reject) {
          _this._promise.then(function (r) {
            if (_this._canceled) {
              p.cancel();
            }

            if (success && !_this._canceled) {
              handleCallback(resolve, reject, success, r);
            } else {
              resolve(r);
            }
          }, function (r) {
            if (_this._canceled) {
              p.cancel();
            }

            if (error && !_this._canceled) {
              handleCallback(resolve, reject, error, r);
            } else {
              reject(r);
            }
          });
        });
        return p;
      }
    }, {
      key: "catch",
      value: function _catch(error) {
        return this.then(undefined, error);
      }
    }, {
      key: "cancel",
      value: function cancel(errorCallback) {
        this._canceled = true;

        if (errorCallback) {
          this._promise.catch(errorCallback);
        }

        return this;
      }
    }]);
    return CancelablePromise;
  }();

  var LayerModel = function () {
    function LayerModel() {
      var layerSpec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      classCallCheck(this, LayerModel);
      this.opacity = 1;
      this.visibility = true;
      this.source = {};
      this.render = {};
      Object.assign(this, layerSpec, {
        changedAttributes: {}
      });
    }

    createClass(LayerModel, [{
      key: 'get',
      value: function get$$1(key) {
        return this[key];
      }
    }, {
      key: 'set',
      value: function set$$1(key, value) {
        this[key] = value;
        return this;
      }
    }, {
      key: 'update',
      value: function update(layerSpec) {
        var _this = this;

        var prevData = _extends({}, this);

        var nextData = _extends({}, layerSpec); // reseting changedAttributes for every update


        this.set('changedAttributes', {});
        Object.keys(nextData).forEach(function (k) {
          if (!isEqual(prevData[k], nextData[k])) {
            _this.changedAttributes[k] = nextData[k];

            _this.set(k, nextData[k]);
          }
        });
      }
    }]);
    return LayerModel;
  }();

  var headers = {
    'Content-Type': 'application/json'
  };

  var get$1 = function get$$1(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return axios__default.get(url, _extends({
      headers: headers
    }, options));
  };

  var post = function post(url, body) {
    return axios__default.post(url, body, {
      headers: headers
    });
  };

  var fetch = function fetch(type, url, options, layerModel) {
    var layerRequest = layerModel.layerRequest;

    if (layerRequest) {
      layerRequest.cancel('Operation canceled by the user.');
    }

    var layerRequestSource = axios.CancelToken.source();
    layerModel.set('layerRequest', layerRequestSource);
    var method = type === 'post' ? post : get$1;
    var newLayerRequest = method(url, _extends({}, options, {
      cancelToken: layerRequestSource.token
    })).then(function (res) {
      if (res.status > 400) {
        console.error(res);
        return false;
      }

      return res.data;
    });
    return newLayerRequest;
  };

  var DEFAULT_PROVIDERS = {
    carto: function carto(layerModel, layer, resolve, reject) {
      var interactivity = layerModel.interactivity,
          source = layerModel.source;
      var provider = source.provider;
      var layerTpl = JSON.stringify({
        version: '1.3.0',
        stat_tag: 'API',
        layers: provider.layers.map(function (l) {
          if (!!interactivity && interactivity.length) {
            return _extends({}, l, {
              options: _extends({}, l.options, {
                interactivity: interactivity
              })
            });
          }

          return l;
        })
      }); // https://carto.com/developers/auth-api/guides/how-to-send-API-Keys/

      var apiParams = _extends({
        stat_tag: 'API',
        config: encodeURIComponent(layerTpl)
      }, provider.api_key && {
        api_key: provider.api_key
      });

      var apiParamsString = Object.keys(apiParams).map(function (k) {
        return k + '=' + apiParams[k];
      }).join('&');
      var url = 'https://' + provider.account + '.carto.com/api/v1/map?' + apiParamsString;
      fetch('get', url, {}, layerModel).then(function (response) {
        var ext = layerModel.type === 'vector' ? 'mvt' : 'png';
        var tileUrl = response.cdn_url.templates.https.url.replace('{s}', 'a') + '/' + provider.account + '/api/v1/map/' + response.layergroupid + '/{z}/{x}/{y}.' + ext;
        return resolve(_extends({}, layer, {
          source: _extends({}, omit(layer.source, 'provider'), {
            tiles: [tileUrl]
          })
        }));
      }).catch(function (err) {
        return reject(err);
      });
    }
  };

  function checkPluginProperties(plugin) {
    if (plugin) {
      var requiredProperties = ['add', 'remove', 'setVisibility', 'setOpacity', 'setZIndex', 'setSource', 'setRender', 'setParams', 'setSQLParams', 'setDecodeParams', 'getLayerByType'];
      requiredProperties.forEach(function (property) {
        if (!plugin[property]) {
          console.error('The ' + property + ' function is required for layer manager plugins');
        }
      });
      var deprecatedProperties = ['getLayerByProvider'];
      deprecatedProperties.forEach(function (property) {
        if (plugin[property]) {
          console.warn('The ' + property + ' function is deprecated for layer manager plugins');
        }
      });
    }
  }

  var LayerManager = function () {
    function LayerManager(map, Plugin, Providers) {
      classCallCheck(this, LayerManager);
      this.map = map;
      this.providers = _extends({}, DEFAULT_PROVIDERS, Providers);
      this.layers = [];
      this.promises = {};
      this.options = {
        getLayers: this.getLayers.bind(this)
      };
      this.plugin = new Plugin(this.map, this.options);
      checkPluginProperties(this.plugin);
    }
    /**
     * Add layers
     * @param {Array} layers
     * @param {Object} layerOptions
     */


    createClass(LayerManager, [{
      key: 'add',
      value: function add(layer) {
        var layerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          opacity: 1,
          visibility: true,
          zIndex: 0,
          interactivity: null
        };
        var onAfterAdd = arguments[2];

        if (typeof layer === 'undefined') {
          console.error('layer is required');
          return this;
        }

        var layerModel = new LayerModel(_extends({}, layer, layerOptions));
        var id = layerModel.id;

        if (this.layers.find(function (l) {
          return l.id === id;
        })) {
          return this.layers;
        }

        this.layers.push(layerModel);
        this.requestLayer(layerModel, onAfterAdd);
        return this.layers;
      }
      /**
       * Updating a specific layer
       * @param  {Object} layerModel
       */

    }, {
      key: 'update',
      value: function update(id, changedProps) {
        var layerModel = this.getLayerModel(id);
        if (!layerModel || !layerModel.mapLayer) return;
        layerModel.update(changedProps);
        var opacity = changedProps.opacity,
            visibility = changedProps.visibility,
            zIndex = changedProps.zIndex,
            source = changedProps.source,
            render = changedProps.render,
            params = changedProps.params,
            sqlParams = changedProps.sqlParams,
            decodeParams = changedProps.decodeParams;

        if (typeof opacity !== 'undefined') {
          this.plugin.setOpacity(layerModel, opacity);
        }

        if (typeof visibility !== 'undefined') {
          this.plugin.setVisibility(layerModel, visibility);
        }

        if (typeof zIndex !== 'undefined') {
          this.plugin.setZIndex(layerModel, zIndex);
        }

        if (!isEmpty(source)) {
          this.plugin.setSource(layerModel);
        }

        if (!isEmpty(render)) {
          this.plugin.setRender(layerModel);
        }

        if (!isEmpty(params)) {
          this.plugin.setParams(layerModel);
        }

        if (!isEmpty(sqlParams)) {
          this.plugin.setSqlParams(layerModel);
        }

        if (!isEmpty(decodeParams)) {
          this.plugin.setDecodeParams(layerModel);
        }
      }
      /**
       * Remove a layer giving a Layer ID
       * @param {String} id
       */

    }, {
      key: 'remove',
      value: function remove(id, onAfterRemove) {
        var layers = this.layers.slice(0);
        this.requestCancel(id);
        var layerModel = this.getLayerModel(id);

        if (layerModel) {
          this.plugin.remove(layerModel);
        }

        this.layers = layers.filter(function (l) {
          return l.id !== id;
        });
        onAfterRemove(layerModel);
      }
    }, {
      key: 'getLayers',
      value: function getLayers() {
        return this.layers;
      }
    }, {
      key: 'getLayerModel',
      value: function getLayerModel(id) {
        return this.layers.find(function (l) {
          return l.id === id;
        });
      }
      /**
       * A namespace to set opacity on selected layer
       * @param {String} id
       * @param {Number} opacity
       */

    }, {
      key: 'setOpacity',
      value: function setOpacity(id, opacity) {
        var layerModel = this.getLayerModel(id);
        this.plugin.setOpacity(layerModel, opacity);
      }
      /**
       * A namespace to hide or show a selected layer
       * @param {String} id
       * @param {Boolean} visibility
       */

    }, {
      key: 'setVisibility',
      value: function setVisibility(id, visibility) {
        var layerModel = this.getLayerModel(id);
        this.plugin.setVisibility(layerModel, visibility);
      }
      /**
       * A namespace to set z-index on selected layer
       * @param {String} id
       * @param {Number} zIndex
       */

    }, {
      key: 'setZIndex',
      value: function setZIndex(id, zIndex) {
        var layerModel = this.getLayerModel(id);
        this.plugin.setZIndex(layerModel, zIndex);
      }
    }, {
      key: 'requestLayer',
      value: function requestLayer(layerModel, onAfterAdd) {
        var _this = this;

        var type = layerModel.type;
        var method = this.plugin.getLayerByType(type);

        if (!method) {
          this.promises[layerModel.id] = CancelablePromise.reject(new Error(type + ' type is not yet supported.'));
          return false;
        } // Cancel previous/existing request


        this.requestCancel(layerModel.id); // every request method returns a promise that we store in the array
        // to control when all layers are fetched.

        this.promises[layerModel.id] = method.call(this, layerModel, this.providers).then(function (layer) {
          var canceled = _this.promises[layerModel.id]._canceled;

          if (!canceled) {
            layerModel.set('mapLayer', layer);

            _this.plugin.add(layerModel, _this.layers);

            _this.plugin.setZIndex(layerModel, layerModel.zIndex);

            _this.plugin.setOpacity(layerModel, layerModel.opacity);

            _this.plugin.setVisibility(layerModel, layerModel.visibility);

            _this.plugin.setRender(layerModel);

            onAfterAdd(layerModel);
          }
        });
        return this;
      }
    }, {
      key: 'requestCancel',
      value: function requestCancel(layerModelId) {
        // Cancel previous/existing request
        if (this.promises[layerModelId] && this.promises[layerModelId].cancel) {
          this.promises[layerModelId].cancel();
        }
      }
    }, {
      key: 'unmount',
      value: function unmount() {
        this.map = null;
        this.plugin.unmount();
      }
    }]);
    return LayerManager;
  }();

  var LayerManager$1 = function (_PureComponent) {
    inherits(LayerManager$$1, _PureComponent);

    function LayerManager$$1(props) {
      classCallCheck(this, LayerManager$$1);

      var _this = possibleConstructorReturn(this, (LayerManager$$1.__proto__ || Object.getPrototypeOf(LayerManager$$1)).call(this, props));

      var map = props.map,
          plugin = props.plugin,
          providers = props.providers;
      _this.layerManager = new LayerManager(map, plugin, providers);
      return _this;
    }

    createClass(LayerManager$$1, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.layerManager.unmount();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var children = this.props.children;

        if (children && react.Children.count(children)) {
          return react.Children.map(children, function (child, i) {
            return child && react.cloneElement(child, {
              layerManager: _this2.layerManager,
              zIndex: child.props.zIndex || 1000 - i
            });
          });
        }

        return null;
      }
    }]);
    return LayerManager$$1;
  }(react.PureComponent);

  LayerManager$1.propTypes = {
    map: PropTypes.shape({}).isRequired,
    plugin: PropTypes.func.isRequired,
    providers: PropTypes.shape({}),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
  };
  LayerManager$1.defaultProps = {
    children: [],
    providers: {}
  };
  /**
   * Params should have this format => { key:'xxx', key2:'xxx' }
   * Keys to search should be in this format {{key}}
   * @param {String} originalStr
   * @param {Object} params
   */

  var substitution = function substitution(originalStr) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var str = originalStr;
    Object.keys(params).forEach(function (key) {
      if (Array.isArray(params[key]) || isObject(params[key])) {
        str = str.replace(new RegExp('"{{' + key + '}}"', 'g'), JSON.stringify(params[key])).replace(new RegExp('\'{{' + key + '}}\'', 'g'), JSON.stringify(params[key])).replace(new RegExp('`{{' + key + '}}`', 'g'), JSON.stringify(params[key])).replace(new RegExp('"{' + key + '}"', 'g'), JSON.stringify(params[key])).replace(new RegExp('\'{' + key + '}\'', 'g'), JSON.stringify(params[key])).replace(new RegExp('`{' + key + '}`', 'g'), JSON.stringify(params[key]));
      }

      if (typeof params[key] === 'number' || typeof params[key] === 'boolean') {
        str = str.replace(new RegExp('"{{' + key + '}}"', 'g'), params[key]).replace(new RegExp('\'{{' + key + '}}\'', 'g'), params[key]).replace(new RegExp('`{{' + key + '}}`', 'g'), params[key]).replace(new RegExp('"{' + key + '}"', 'g'), params[key]).replace(new RegExp('\'{' + key + '}\'', 'g'), params[key]).replace(new RegExp('`{' + key + '}`', 'g'), params[key]);
      }

      str = str.replace(new RegExp('{{' + key + '}}', 'g'), params[key]).replace(new RegExp('{' + key + '}', 'g'), params[key]);
    });
    return str;
  };
  /**
   * Params should have this format => { where1: { { key:'xxx', key2:'xxx' } }},
   * Keys to search should be in this format {{key}}
   * @param {String} originalStr
   * @param {Object} params
   */


  var concatenation = function concatenation(originalStr) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var str = originalStr;
    var sql = void 0;
    Object.keys(params).forEach(function (key) {
      sql = '' + compact(Object.keys(params[key]).map(function (k) {
        var value = params[key][k];

        if (Array.isArray(value) && !!value.length) {
          var mappedValue = value.map(function (v) {
            return typeof v !== 'number' ? '\'' + v + '\'' : v;
          });
          return k + ' IN (' + mappedValue.join(', ') + ')';
        }

        if (!Array.isArray(value) && value) {
          return typeof value !== 'number' ? k + ' = \'' + value + '\'' : k + ' = ' + value;
        }

        return null;
      })).join(' AND ');
      if (sql && key.startsWith('where')) sql = 'WHERE ' + sql;else if (sql && key.startsWith('and')) sql = 'AND ' + sql;else sql = '';
      str = str.replace(new RegExp('{{' + key + '}}', 'g'), sql);
      str = str.replace(new RegExp('{' + key + '}', 'g'), sql);
    });
    return str;
  };
  /**
   * Replace function
   * @param {String} string
   * @param {Object} params
   * @param {Object} sqlParams
   */


  var replace = function replace(originalStr) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var sqlParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var str = originalStr;

    if (typeof str === 'string') {
      str = substitution(str, params);
      str = concatenation(str, sqlParams);
    }

    return str;
  };

  var Layer = function (_PureComponent) {
    inherits(Layer, _PureComponent);

    function Layer() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, Layer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Layer.__proto__ || Object.getPrototypeOf(Layer)).call.apply(_ref, [this].concat(args))), _this), _this.add = function () {
        var _this$props = _this.props,
            layerManager = _this$props.layerManager,
            onAfterAdd = _this$props.onAfterAdd,
            props = objectWithoutProperties(_this$props, ['layerManager', 'onAfterAdd']);
        var source = props.source,
            render = props.render,
            params = props.params,
            sqlParams = props.sqlParams;
        var sourceParsed = source.parse === false ? source : JSON.parse(replace(JSON.stringify(source), params, sqlParams));
        var renderParsed = render.parse === false ? render : JSON.parse(replace(JSON.stringify(render), params, sqlParams));
        layerManager.add(_extends({}, props, {
          source: sourceParsed,
          render: renderParsed
        }), {}, onAfterAdd);
      }, _this.update = function (changedProps) {
        var _this$props2 = _this.props,
            layerManager = _this$props2.layerManager,
            id = _this$props2.id;
        layerManager.update(id, changedProps);
      }, _this.remove = function () {
        var _this$props3 = _this.props,
            layerManager = _this$props3.layerManager,
            id = _this$props3.id,
            onAfterRemove = _this$props3.onAfterRemove;
        layerManager.remove(id, onAfterRemove);
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Layer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.add();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var prevSource = prevProps.source,
            prevRender = prevProps.render,
            prevParams = prevProps.params,
            prevSqlParams = prevProps.sqlParams,
            prevDecodeParams = prevProps.decodeParams,
            prevOpacity = prevProps.opacity,
            prevVisibility = prevProps.visibility,
            prevZIndex = prevProps.zIndex;
        var _props = this.props,
            type = _props.type,
            source = _props.source,
            render = _props.render,
            params = _props.params,
            sqlParams = _props.sqlParams,
            decodeParams = _props.decodeParams,
            opacity = _props.opacity,
            visibility = _props.visibility,
            zIndex = _props.zIndex; // Check that source has changed

        var prevSourceParsed = prevSource.parse === false ? prevSource : JSON.parse(replace(JSON.stringify(prevSource), prevParams, prevSqlParams));
        var sourceParsed = source.parse === false ? source : JSON.parse(replace(JSON.stringify(source), params, sqlParams)); // Check that render has changed

        var prevRenderParsed = prevRender.parse === false ? prevRender : JSON.parse(replace(JSON.stringify(prevRender), prevParams, prevSqlParams));
        var renderParsed = render.parse === false ? render : JSON.parse(replace(JSON.stringify(render), params, sqlParams)); // TODO: don't add and remove if provider is geojson

        if (sourceParsed && !isEqual(sourceParsed, prevSourceParsed)) {
          var sourceType = sourceParsed.type,
              data = sourceParsed.data;
          var t = sourceType || type;

          if (t === 'raster' || t === 'vector' || t === 'geojson' && typeof data === 'string') {
            this.remove();
            this.add(); // prevent updating layer

            return;
          }
        }

        if (renderParsed && !isEqual(renderParsed, prevRenderParsed)) {
          var _renderParsed$layers = renderParsed.layers,
              layers = _renderParsed$layers === undefined ? [] : _renderParsed$layers;
          var _prevRenderParsed$lay = prevRenderParsed.layers,
              prevLayers = _prevRenderParsed$lay === undefined ? [] : _prevRenderParsed$lay;

          if (layers.length !== prevLayers.length) {
            this.remove();
            this.add(); // prevent updating layer

            return;
          }
        }

        var changedProps = _extends({}, opacity !== prevOpacity && {
          opacity: opacity
        }, visibility !== prevVisibility && {
          visibility: visibility
        }, zIndex !== prevZIndex && {
          zIndex: zIndex
        }, !isEqual(sourceParsed, prevRenderParsed) && {
          source: sourceParsed
        }, !isEqual(renderParsed, prevRenderParsed) && {
          render: renderParsed
        }, !isEqual(decodeParams, prevDecodeParams) && {
          decodeParams: decodeParams
        });

        if (!isEmpty(changedProps)) {
          this.update(changedProps);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.remove();
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return Layer;
  }(react.PureComponent);

  Layer.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.oneOf(['raster', 'vector', 'geojson']).isRequired,
    source: PropTypes.shape({
      parse: PropTypes.bool
    }).isRequired,
    render: function render(props, propName, componentName) {
      var type = props.type;

      if (type === 'vector' && isEmpty(props[propName])) {
        return new Error('The prop \'' + propName + '\' is marked as required in \'' + componentName + '\', but its value is {}');
      }

      if (_typeof(props[propName]) !== 'object') {
        return new Error('Invalid prop \'' + propName + '\' of type \'' + _typeof(props[propName]) + '\' supplied to \'' + componentName + '\', expected \'object\'.');
      }

      return null;
    },
    params: PropTypes.shape({}),
    sqlParams: PropTypes.shape({}),
    decodeParams: PropTypes.shape({}),
    opacity: PropTypes.number,
    visibility: PropTypes.bool,
    zIndex: PropTypes.number,
    onAfterAdd: PropTypes.func,
    onAfterRemove: PropTypes.func,
    layerManager: PropTypes.shape({
      add: PropTypes.func.isRequired,
      update: PropTypes.func.isRequired,
      remove: PropTypes.func.isRequired,
      map: PropTypes.shape({
        getSource: PropTypes.func
      })
    })
  };
  Layer.defaultProps = {
    params: undefined,
    sqlParams: undefined,
    decodeParams: undefined,
    opacity: 1,
    visibility: true,
    zIndex: undefined,
    render: {},
    layerManager: null,
    onAfterAdd: function onAfterAdd() {},
    onAfterRemove: function onAfterRemove() {}
  }; // This file exists as an entry point for bundling our umd builds.

  var Components = {};
  Components.LayerManager = LayerManager$1;
  Components.Layer = Layer;
  return Components;
});